import React, { useState, useEffect } from 'react';
import { API } from './shared';

const EXPIRY = new Date('2026-08-22T00:00:00');

const TechBridgePopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (new Date() >= EXPIRY) return;
    const dismissed = sessionStorage.getItem('techbridge-dismissed');
    if (!dismissed) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem('techbridge-dismissed', '1');
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="techbridge-popup">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={dismiss} />
      <div className="relative max-w-lg w-full animate-in fade-in zoom-in duration-500">
        <button
          onClick={dismiss}
          className="absolute -top-3 -right-3 z-10 w-8 h-8 bg-white text-[#0B1A2B] rounded-full flex items-center justify-center text-lg font-bold shadow-lg hover:bg-[#D97706] hover:text-white transition-colors cursor-pointer"
          data-testid="popup-close"
          aria-label="Close"
        >
          &times;
        </button>
        <a
          href="https://techbridge.org/events/digital-ball/"
          target="_blank"
          rel="noopener noreferrer"
          className="block overflow-hidden shadow-2xl"
        >
          <img
            src={`${API}/resources/techbridge-sponsorship.png`}
            alt="APIG is a proud Silver Sponsor of the TechBridge Digital Ball — August 22, 2026"
            className="w-full h-auto"
          />
        </a>
      </div>
    </div>
  );
};

export default TechBridgePopup;
